import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { map, publishLast, refCount, take } from 'rxjs/operators';
import { Validation, ContractType, PersonType } from '../../models';
import { ErrorMessage, CssClass } from '../../constants';
import { GtmDatalayerUiService } from '../gtm-datalayer/gtm-datalayer-ui.service';

@Injectable({
  providedIn: 'root'
})
export class PrivacyPolicyValidationService {
  constructor(private gtmDataLayerUiService: GtmDatalayerUiService) {

  }

  privacyPolicyValidSubject: Subject<Validation> = new Subject<Validation>();
  privacyPolicyValid$ = this.privacyPolicyValidSubject.asObservable();
  private error: Validation = new Validation();
  isInValid(isChecked: boolean): boolean {
    let validation = this.privacyPolicyValidation(isChecked)
    this.setError(validation);
    return validation.isInValid;
  }
  private privacyPolicyValidation(isChecked: boolean): Validation {
    let validation: Validation = new Validation();
    validation.isInValid = false;
    if (!isChecked) {
      validation.isInValid = true;
      validation.errorCss = CssClass.error;
      this.gtmDataLayerUiService.setCjError(ErrorMessage.privacy)
    }
    return validation;
  }
  setError(error: Validation) {
    this.privacyPolicyValidSubject.next(error);
  }
}
